export const order = 8;
export const routes = {
  path: '/',
  name: 'personalCenterLayout',
  component: () => import('@/views/layout'),
  meta: {
    title: '个人中心',
    guard: {
      role: ['Admin'],
      permission: ['upms:personalCenter'],
    },
  },
  children: [
    {
      path: 'personalCenterPage',
      name: 'personalCenterPage',
      meta: {
        title: '个人中心',
      },
      component: () => import('@/views/personalCenter'),
    },
    {
      path: 'message',
      name: 'MessageAlerts',
      component: () => import('@/views/personalCenter/message.vue'),
      meta: {
        title: '消息提醒',
        hidden: true,
      },
    },
  ],
};
export const perms = {};
